import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class StaticBarModel extends BaseModel {
  @attr("json") age;
  @attr("json") allInNetworkAppointmentsCount;
  @attr("json") allInNetworkProvidersCount;
  @attr("json") allOutNetworkAppointmentsCount;
  @attr("json") allOutOfNetworkProvidersCount;
  @attr("json") campaign;
  @attr("json") colorState;
  @attr("json") commStatus;
  @attr("json") coverageStatus;
  @attr("json") currentBalanceTotal;
  @attr("json") dateOfAccident;
  @attr("json") dateOfBirth;
  @attr("json") incidentCity;
  @attr("json") incidentRole;
  @attr("json") incidentState;
  @attr("json") incidentType;
  @attr("json") latestAppointmentDate;
  @attr("json") latestProviderName;
  @attr("json") legalStatus;
  @attr("json") legalStatusUpdatedAt;
  @attr("json") legalStatusUpdatedBy;
  @attr("json") liabilityStatus;
  @attr("json") maxPainBodyPart;
  @attr("json") maxPainLevel;
  @attr("json") medicalLimits;
  @attr("json") name;
  @attr("json") namePrefix;
  @attr("json") nextAppointmentDate;
  @attr("json") nextProviderName;
  @attr("json") overallStatus;
  @attr("json") overallStatusUpdatedAt;
  @attr("json") overallStatusUpdatedBy;
  @attr("json") phone;
  @attr("json") preferredLanguage;
  @attr("json") propertyDamageSeverity;
  @attr("json") providerMax;
  @attr("json") relatedCases;
  @attr("json") runningTotal;
  @attr("json") status;
  @attr("json") statusUpdatedAt;
  @attr("json") statusUpdatedBy;
  @attr("json") statuteOfLimitations;
}
